import { Box } from '@mui/material';
import { NAV } from 'src/layouts/config-layout';
import PropTypes from 'prop-types';

import JobCreationNavbar from './sections/navbar';
import JobCreationHeader from './sections/header';

export default function JobCreateViewLayout({ children }) {
  return (
    <>
      <JobCreationHeader />
      <Box
        sx={{
          minHeight: 1,
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
        }}
      >
        <JobCreationNavbar />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            minHeight: 1,
            display: 'flex',
            flexDirection: 'column',
            pl: '40px',
            py: '20px',
            pt: '140px',
            width: `calc(100% - ${NAV.W_VERTICAL}px)`,
            background: theme => theme.palette.background.primaryGrey1,
          }}
        >
          {children}
        </Box>
      </Box>
    </>
  );
}

JobCreateViewLayout.propTypes = {
  children: PropTypes.node,
};
